export default __webpack_public_path__ + "static/media/carousel_2.9572aa16.jpg";